import { AssetInScene } from '../AssetInScene';

export class QuestionResponse {
    questionResponseId: number;
    questionAssetId: number;
    text: string;
    textSize: number;
    textColour: string;
    isCorrect: boolean;
    hasImage: boolean;
    imageSceneAssetRelationId: number;
    hasVideo: boolean;
    videoSceneAssetRelationId: number;
    hasAudio: boolean;
    audioSceneAssetRelationId: number;
    hasLinkedScene: boolean;
    linkedSceneID: number;
    questionResponseIndex: number;
    fontFamily: string;
    assets: AssetInScene[];
    toBeRemoved: boolean;
}